import axios from "axios";
import { ADD_MACHINE, ADMIN_LOGIN, DOMAIN_NAME, GET_CLIENTS, GET_MACHINES, GET_REPORT_ADMIN, UPDATE_JACKPOT_MACHINE, UPDATE_JACKPOT_VALUES } from '../constants'; 
import { reqHeader } from "./_reqHeader";

const getClients = (callback) => {
    axios.get(DOMAIN_NAME + GET_CLIENTS, {headers: reqHeader.apiHeader()}).then(response => {
        callback(response.data)
    })
}

const addMachine = (data, callback) => {
    axios.post(DOMAIN_NAME + ADD_MACHINE, data, {headers: reqHeader.apiHeader()}).then(response => {
        callback(response.data)
    })
}

const getMachines = (callback) => {
    axios.get(DOMAIN_NAME + GET_MACHINES, {headers: reqHeader.apiHeader()}).then(response => {
        callback(response.data)
    })
}

const getReportForAdmin = (callback) => {
    axios.post(DOMAIN_NAME + GET_REPORT_ADMIN, {headers: reqHeader.apiHeader()}).then(response => {
        callback(response.data)
    })
}

const updateJackpotForMachine = (data, callback) => {
    axios.post(DOMAIN_NAME + UPDATE_JACKPOT_MACHINE, data, {headers: reqHeader.apiHeader()}).then(response => {
        callback(response.data)
    })
}
const updateJackpotValues = (data, callback) => {
    axios.post(DOMAIN_NAME + UPDATE_JACKPOT_VALUES, data, {headers: reqHeader.apiHeader()}).then(response => {
        callback(response.data)
    })
}

const adminLogin = (data, callback) => {
    axios.post(DOMAIN_NAME + ADMIN_LOGIN, data, {headers: reqHeader.apiHeader()}).then(response => {
        callback(response.data)
    })
}

export {
    getClients,
    addMachine,
    getMachines,
    getReportForAdmin,
    adminLogin,
    updateJackpotForMachine,
    updateJackpotValues
}